import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CustomerState, GetCustomersParams } from "@/types/admin/customer-type";
import { customerService } from "@/services/system-admin/admin-data.service";

const initialState: CustomerState = {
  customers: [],
  loading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 20,
};

export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers",
  async (params: GetCustomersParams) => {
    const response = await customerService.getCustomers(params);
    return { ...response, page: params.page, pageSize: params.pageSize };
  }
);

// const customerSlice = createSlice({
//   name: "customers",
//   initialState,
//   reducers: {
//     clearError: (state) => { state.error = null; },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCustomers.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCustomers.fulfilled, (state, action) => {
//         state.loading = false;
//         const list = action.payload.items || action.payload.data || action.payload.result?.items || [];
//         state.customers = list;
//         state.currentPage = action.payload.page || 1;
//         state.pageSize = action.payload.pageSize || 20;
//         if (list.length > 0) {
//           state.totalCount = list[0].totalCount || action.payload.totalCount || action.payload.result?.totalCount || 0;
//         } else {
//           state.totalCount = action.payload.totalCount || action.payload.result?.totalCount || 0;
//         }
//       })
//       .addCase(fetchCustomers.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || "Failed to fetch customers";
//       });
//   },
// });

const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        const list = action.payload.result?.items || [];
        state.customers = list;
        state.currentPage = action.payload.page || 1;
        state.pageSize = action.payload.pageSize || 20;
        // ✅ API returns totalRecordCount inside each item
        state.totalCount = list[0]?.totalRecordCount || 0;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch customers";
      });
  },
});

export const { clearError } = customerSlice.actions;
export default customerSlice.reducer;
